function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import { modalActions } from '../../../reducers/modal.reducer';
import { settingsActions } from '../../../reducers/settings.reducer';
import Button from '../../common/Button.react';
import ModalHeader from '../../modal/ModalHeader.react';

// TODO :: Remove blankspace in password
var FeatureFlagsAdd = function FeatureFlagsAdd(_ref) {
  var _ref$clientApp = _ref.clientApp,
    clientApp = _ref$clientApp === void 0 ? 'cms' : _ref$clientApp,
    featureFlagConstants = _ref.featureFlagConstants,
    hideModalAction = _ref.hideModalAction,
    setFeatureFlagsAction = _ref.setFeatureFlagsAction;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState('auth'),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedFlag = _useState4[0],
    setSelectedFlag = _useState4[1];
  var _useState5 = useState('dev'),
    _useState6 = _slicedToArray(_useState5, 2),
    environment = _useState6[0],
    setEnvironment = _useState6[1];
  var _useState7 = useState('on'),
    _useState8 = _slicedToArray(_useState7, 2),
    value = _useState8[0],
    setValue = _useState8[1];
  var isValid = function isValid() {
    return selectedFlag.length > 0 && value.length > 0 && environment.length > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Edit ".concat(clientApp === 'dev' ? 'Development' : 'Production', " Flags")
  }), /*#__PURE__*/React.createElement("select", {
    value: selectedFlag,
    onChange: function onChange(e) {
      setSelectedFlag(e.target.value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Select Flag"), featureFlagConstants.filter(function (x) {
    return x.clientApp === clientApp;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("option", {
      value: x.name,
      key: "".concat(id).concat(x.name)
    }, x.name);
  })), /*#__PURE__*/React.createElement("select", {
    value: value,
    onChange: function onChange(e) {
      setValue(e.target.value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Select Value"), /*#__PURE__*/React.createElement("option", {
    value: "on"
  }, "On"), /*#__PURE__*/React.createElement("option", {
    value: "off"
  }, "Off")), /*#__PURE__*/React.createElement("select", {
    value: environment,
    onChange: function onChange(e) {
      setEnvironment(e.target.value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Select Environment"), /*#__PURE__*/React.createElement("option", {
    value: "dev"
  }, "Development"), /*#__PURE__*/React.createElement("option", {
    value: "production"
  }, "Production")), /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    onClick: function onClick() {
      setFeatureFlagsAction({
        id: null,
        clientApp: clientApp,
        environment: environment,
        key: selectedFlag,
        value: value === 'on' ? true : false
      });
      hideModalAction();
    },
    width: "120px",
    style: {
      marginTop: 20
    },
    disabled: !isValid()
  }));
};
var mdtp = {
  usersAction: cmsActions.users,
  hideModalAction: modalActions.hide,
  setFeatureFlagsAction: settingsActions.setFeatureFlags
};
export default connect(null, mdtp)(FeatureFlagsAdd);